import axios from '@axios'
import store from '@/store'
import overlayTimeout from '@/velta/components/crud/mixins/overlayTimeout'

export default function storeModule() {
    // Inicializa o monitoramento do overlay
    overlayTimeout('ordemservico')

    if (!store.hasModule('ordemservico')) {
        store.registerModule('ordemservico', {
            namespaced: true,
            state: {
                overlay: false,
                dados: {},
                dadosReagendamento: null,
                vagas: [],
                vagasSelecionadas: [],
                options: [],
                recorrencia: false,
            },
            mutations: {
                setOverlay(state, overlay) {
                    state.overlay = overlay
                },
                setDados(state, dados) {
                    state.dados = dados
                },
                setDadosReagendamento(state, dados) {
                    state.dadosReagendamento = dados
                },
                setVagas(state, vagas) {
                    state.vagas = vagas
                },
                setVagasSelecionadas(state, val) {
                    state.vagasSelecionadas = val
                },
                setOptions(state, options) {
                    state.options = options;

                    // Auto-preenche grupo_estoque_consumo_id quando o filtro
                    // de grupo está ativo (usuário com vagas vinculadas) e
                    // só há uma opção possível. Replica no campo da OS o
                    // único grupo permitido — pareado com o disabled+!clearable
                    // no template, dá a sensação de "campo travado".
                    const lista = Array.isArray(options?.optionsGruposEstoque) ? options.optionsGruposEstoque : [];
                    if (options?.gruposEstoqueFiltroAtivo && lista.length === 1 && state.dados) {
                        state.dados = {
                            ...state.dados,
                            grupo_estoque_consumo_id: lista[0].value,
                        };
                    }
                },
                setRecorrencia(state, recorrencia) {
                    state.recorrencia = recorrencia;
                },
            },
            getters: {
                getOptions(state) {
                    return state.options
                }
            },
            actions: {
                fetch(ctx) {
                    return new Promise((resolve, reject) => {
                        axios.get('/api/agendamento/fetch').then((response) => {
                            ctx.commit('setVagas', response.data.vagas);
                            ctx.commit('setVagasSelecionadas', ctx.state.vagas.map((val) => val.id));

                            return resolve(response)
                        }).catch((error) => {
                            ctx.commit('setVagas', {});
                            ctx.commit('vagasSelecionadas', []);

                            return reject(error)
                        })
                    })
                },
                fetchEvents(ctx, info) {
                    return new Promise((resolve, reject) => {
                        axios.get('/api/agendamento/fetchEvents', {
                            params: {
                                vagas: ctx.state.vagasSelecionadas.join(','),
                                ...info
                            },
                        }).then((response) => resolve(response)).catch((error) => reject(error))
                    })
                },
                fetchOptions(ctx, agendamentoId = null) {
                    return new Promise((resolve, reject) => {
                        axios.get(`/api/agendamento/fetchOptions?agendamentoId=${agendamentoId}`).then((response) => resolve(response)).catch((error) => reject(error))
                    })
                },
                fetchFormasPagamentos(ctx) {
                    return new Promise((resolve, reject) => {
                        axios.get('/api/formasdepagamentos/fetchAll').then((response) => resolve(response)).catch((error) => reject(error))
                    })
                },
                fetchClienteVeiculo(ctx, id) {
                    return new Promise((resolve, reject) => {
                        axios.get('/api/agendamento/fetchClienteVeiculo', { params: { id }}).then((response) => resolve(response)).catch((error) => reject(error))
                    })
                },
                fetchInfoAgendamento(ctx, id) {
                    return new Promise((resolve, reject) => {
                        axios.get('/api/agendamento/fetchInfoAgendamento', { params: { id }}).then((response) => resolve(response)).catch((error) => reject(error))
                    })
                },
                store({ state }, dados) {
                    return new Promise((resolve, reject) => {
                        axios.post('/api/agendamento/store', { ...state.dados, ...dados}).then((response) => resolve(response)).catch((error) => reject(error))
                    })
                },
                update({ state }, dados) {
                    return new Promise((resolve, reject) => {
                        axios.post('/api/agendamento/update', { ...state.dados, ...dados}).then((response) => resolve(response)).catch((error) => reject(error))
                    })
                },
                destroy(ctx, params = {}) {
                    return new Promise((resolve, reject) => {
                        axios.get('/api/agendamento/destroy', {
                            params,
                        }).then((response) => resolve(response)).catch((error) => reject(error))
                    })
                },
                cancelar(ctx, dados) {
                    return new Promise((resolve, reject) => {
                        axios.post('/api/agendamento/cancelar', dados)
                            .then((response) => resolve(response))
                            .catch((error) => reject(error))
                    })
                },
                fetchAgendamentosCancelados(ctx, params = {}) {
                    return new Promise((resolve, reject) => {
                        axios.get('/api/agendamento/fetchAgendamentosCancelados', { params })
                            .then((response) => resolve(response))
                            .catch((error) => reject(error))
                    })
                },
                fetchAgendamentoCancelado(ctx, id) {
                    return new Promise((resolve, reject) => {
                        axios.get('/api/agendamento/fetchAgendamentoCancelado', { params: { id } })
                            .then((response) => resolve(response))
                            .catch((error) => reject(error))
                    })
                },
                reagendar(ctx, dados) {
                    return new Promise((resolve, reject) => {
                        axios.post('/api/agendamento/reagendar', dados)
                            .then((response) => resolve(response))
                            .catch((error) => reject(error))
                    })
                },
            },
        })
    }

    // O módulo permanece registrado durante toda a sessão (pré-registrado em App.vue).
    // Why: desregistrar em onUnmounted causava race condition com a transição de rota —
    // o Calendar.vue disparava ações async (fetch/fetchEvents) que tentavam commitar mutations
    // depois do unregister, gerando "[vuex] unknown local mutation type: setVagas" e similares.
}
